module.exports = __webpack_public_path__ + "img/renovation-g860ec0e05_640 - Copie.8d3c1201.jpg";